import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
// import EditUserForm from 'components/Admin/User/EditUserForm';
import ProfileForm from "components/Profile/Profile";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";
import { toast } from "react-toastify";

const { ERROR_TYPE_USER_UPDATE_ERROR, ADMIN_UPDATE_USER_SAGA } = constants;

const {
  loadEditUser,
  adminUpdateUserSaga,
  addValidateError,
  cleanErrors,
  loadDisciplinesSaga,
} = actions;

const userRoles = {
  gp: 0,
  gp_trainee: 1,
  nurse: 2,
  consultant: 3,
  hospital_doctor: 4,
  nurse_specialist: 6,
  allied_healthcare_professional: 7,
  pharmacist: 9,
  // midwifery: 11,
  industry: 11,
};

const disciplineNumberByRole = {
  gp: 1,
  gp_trainee: 1,
  nurse: 1,
  consultant: 5,
  hospital_doctor: 5,
  nurse_specialist: 5,
  allied_healthcare_professional: 1,
  pharmacist: 9,
};

class EditUser extends Component {
  static propTypes = {
    createUser: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    const user = this.props.user;
    this.state = {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        user_type: "",
        phone: null,
        imc: "",
        pin_number: "",
        registration: "",
        registration_number: "",
        county: "",
        practice_name: "",
        hospital: "",
        role: "",
        title: "",
        email_confirmed: "",
        ipna_member: false,
        accreditation: false,
        password: "",
        // county: '',
        branch: "",
        disciplines: [],
        company_name: "",
        position: "",
        ...user,
      },
    };
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.props.user, props.user))
      this.setState({
        user: {
          ...this.state.user,
          ...props.user,
        },
      });
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadEditUser(this.props.params.id);
    this.props.loadDisciplines(
      userRoles[this.props.user && this.props.user.user_type],
    );
  }

  onFieldChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    if (e.target.name === "user_type") {
      this.props.loadDisciplines(userRoles[e.target.value]);
      userData.disciplines = [];
    }

    this.setState({ user: userData }); //, this.validateUser);
  };

  onSelectChangeDiscipline = (disciplines) => {
    const disciplineIds = this.state.user.disciplines;
    const isRemoveDiscipline =
      disciplines.length < ((disciplineIds && disciplineIds.length) || 0);

    if (
      !isRemoveDiscipline &&
      disciplineNumberByRole[this.state.user.user_type] <=
        ((disciplineIds && disciplineIds.length) || 0)
    ) {
      return;
    }
    this.onFieldChange({
      target: {
        name: "disciplines",
        value: disciplines,
      },
    });
  };

  onIpnaChange = (event) => {
    if (!(event.target.value == "true")) {
      const userData = {
        ...this.state.user,
        ...{
          ipna_member: event.target.value == "true",
          branch: null,
        },
      };
      this.setState({ user: userData });
    } else {
      const userData = {
        ...this.state.user,
        ...{
          ipna_member: event.target.value == "true",
        },
      };
      this.setState({ user: userData });
    }
  };

  onAccreditaionChange = (event) => {
    if (event.target.value == "true") {
      const userData = {
        ...this.state.user,
        ...{
          accreditation: event.target.value == "true",
          country: null,
        },
      };
      this.setState({ user: userData });
    } else {
      const userData = {
        ...this.state.user,
        ...{
          accreditation: event.target.value == "true",
        },
      };
      this.setState({ user: userData });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (this.state.user.ipna_member && !this.state.user.branch) {
      toast.warning("Branch required.");
      return;
    }
    if (this.state.user.user_type === "industry") {
      if (!(this.state.user.company_name || "").trim()) {
        toast.warning("Company name is required.");
        return;
      }
      if (!(this.state.user.position || "").trim()) {
        toast.warning("Position/role in the company is required.");
        return;
      }
    }
    // if (!this.state.user.disciplines || !this.state.user.disciplines.length) {
    //   toast.warning('Disciplines required')
    //   return;
    // }
    const userData = {
      ...this.state.user,
      ...{
        disciplines: this.state.user.disciplines.map((d) => d.value || d.id),
      },
    };
    this.setState({ user: userData });

    this.props.adminUpdateUser(userData);
  };

  irishRoleFields = () => {
    switch (this.state.user.user_type) {
      case "gp":
        return ["imc", "practice_name"];
      case "gp_trainee":
        return ["imc", "practice_name"];
      case "consultant":
        return ["imc", "hospital"];
      case "hospital_doctor":
        return ["imc", "hospital"];
      case "nurse_specialist":
        return ["registration", "pin_number"];
      case "nurse":
        return ["practice_name", "pin_number"];
      case "allied_healthcare_professional":
        return ["registration", "profession", "practice_name"];
      case "pharmacist":
        return ["registration_number"];
      case "midwifery":
        return ["registration", "pin_number"];
      case "registered_general_nurses":
        return ["registration", "pin_number"];
      case "industry":
        return ["company_name", "position", "registration_number"];
      default:
        return [];
    }
  };

  internationRoleFields = () => {
    switch (this.state.user.user_type) {
      case "gp":
        return ["registration", "practice_name"];
      case "gp_trainee":
        return ["registration", "practice_name"];
      case "consultant":
        return ["registration", "hospital"];
      case "hospital_doctor":
        return ["registration", "hospital"];
      // case "practice_nurse":
      //   return ["registration", "pin_number"];
      case "nurse_specialist":
        return ["registration", "pin_number"];
      case "nurse":
        return ["practice_name", "pin_number"];
      case "allied_healthcare_professional":
        return ["profession", "registration", "practice_name"];
      case "pharmacist":
        return ["registration_number"];
      case "midwifery":
        return ["registration", "pin_number"];
      case "registered_general_nurses":
        return ["registration", "pin_number"];
      case "industry":
        return ["company_name", "position", "registration_number"];
      default:
        return [];
    }
  };

  onCountyChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ county: e.value },
    };
    this.setState({ user: userData });
  };

  onRoleChange = (e) => {
    this.onFieldChange(e);
  };

  onCountryChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        country: status.value,
      },
    };

    this.setState({ user: userData });
  };

  onBranchChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        branch: status.value,
      },
    };

    this.setState({ user: userData });
  };

  handleIsUserSuperhost = (event) => {
    if (event.target.value == "true") {
      const userData = {
        ...this.state.user,
        role: "superhost",
      };
      this.setState({ user: userData });
    } else {
      const userData = {
        ...this.state.user,
        role: "user",
      };
      this.setState({ user: userData });
    }
  };

  render() {
    const { errors, errorsFrontend } = this.props;
    const outErrors = Object.keys(errorsFrontend || {}).length
      ? errorsFrontend
      : errors;

    return (
      <main className="site--width clearfix-c">
        <h2 className="main_title">User #{this.state.user.id}</h2>
        <ProfileForm
          user={this.state.user}
          onFieldChange={this.onFieldChange}
          onSubmit={this.onSubmit}
          errors={outErrors || {}}
          onRoleChange={this.onRoleChange}
          irishRoleFields={this.irishRoleFields()}
          internationRoleFields={this.internationRoleFields()}
          onAccreditaionChange={this.onAccreditaionChange}
          onIpnaChange={this.onIpnaChange}
          onBranchChange={this.onBranchChange}
          onCountryChange={this.onCountryChange}
          onCountyChange={this.onCountyChange}
          disciplines={this.props.disciplines}
          onSelectChangeDiscipline={this.onSelectChangeDiscipline}
          handleIsUserSuperhost={this.handleIsUserSuperhost}
          is_admin={true}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ADMIN_UPDATE_USER_SAGA],
  errorsFrontend: state.errors[`${ADMIN_UPDATE_USER_SAGA}_FRONTEND`],
  user: state.users.tmp,
  disciplines: state.disciplines.list.values,
  count: state.disciplines.list.count,
  total_pages: state.disciplines.list.total_pages,
  page: state.disciplines.list.page,
  query: state.disciplines.list.query,
});

const mapDispatchToProps = (dispatch) => ({
  loadEditUser: (id) => dispatch(loadEditUser(id)),
  adminUpdateUser: (user) => dispatch(adminUpdateUserSaga(user)),
  validateUser: (errors) =>
    dispatch(addValidateError(ADMIN_UPDATE_USER_SAGA, errors)),
  cleanErrors: () => dispatch(cleanErrors(ADMIN_UPDATE_USER_SAGA)),
  loadDisciplines: (userType) =>
    dispatch(loadDisciplinesSaga(1, { discipline_type: userType })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);



// WEBPACK FOOTER //
// ./src/containers/Admin/User/EditUser.jsx